import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cheapestcabserviceingoa() {



    const cardData = {


keyword: "Cheapest Cab Service in Goa",

headingDescription: "Belgaum Taxi Service offers one of the cheapest cab services in Goa without compromising on safety, comfort, or service quality. We provide affordable taxi services for airport transfers, hotel pickups, sightseeing tours, corporate travel, family vacations, railway station transfers, and outstation journeys across Goa. Whether you need a one-way cab, round-trip taxi, full-day rental, or a customized travel package, our fleet includes economical Sedan cars, Ertiga, SUVs, Innova, Innova Crysta, Tempo Travellers, and premium vehicles at competitive prices. With transparent fares, professional chauffeurs, clean and well-maintained vehicles, doorstep pickup, flexible travel schedules, easy online booking, and 24/7 customer support, Belgaum Taxi Service makes every journey comfortable and budget-friendly. Travelers looking for affordable Goa taxi services can choose our reliable cab solutions for both local sightseeing and outstation travel across Karnataka and Maharashtra. Competitive pricing and transparent fare structures are key considerations for travelers choosing cab services in Goa. :contentReference[oaicite:0]{index=0}",

topPlaces: [
  {
    title: "Belgaum",
    description: "Belgaum is one of the most booked outstation destinations from Goa, offering excellent road connectivity for business travel, family visits, and weekend trips."
  },
  {
    title: "Amboli",
    description: "Amboli is a scenic hill station near Goa, famous for misty mountains, waterfalls, lush forests, and beautiful viewpoints, making it a perfect weekend getaway."
  },
  {
    title: "Dandeli",
    description: "Dandeli is a leading adventure destination known for river rafting, jungle safaris, wildlife, trekking, and nature tourism, attracting visitors throughout the year."
  },
  {
    title: "Gokarna",
    description: "Gokarna is a peaceful coastal town renowned for Om Beach, Kudle Beach, temples, beach cafés, and relaxing seaside holidays."
  },
  {
    title: "Hubballi",
    description: "Hubballi is an important commercial and educational city in Karnataka, frequently visited for business meetings, shopping, healthcare, and corporate travel."
  },
  {
    title: "Kolhapur",
    description: "Kolhapur is a historic city famous for Mahalaxmi Temple, traditional cuisine, shopping markets, and rich cultural heritage, making it a popular outstation destination."
  },
  {
    title: "Pune",
    description: "Pune is a major IT and business hub offering corporate offices, educational institutions, shopping centers, and historical attractions, making it a preferred long-distance travel destination."
  },
  {
    title: "Mumbai",
    description: "Mumbai is India's financial capital, known for international airports, business districts, iconic landmarks, entertainment venues, and commercial centers."
  },
  {
    title: "Mahabaleshwar",
    description: "Mahabaleshwar is a beautiful hill station famous for strawberry farms, scenic viewpoints, lakes, waterfalls, and pleasant weather throughout the year."
  },
  {
    title: "Bangalore",
    description: "Bangalore is a leading technology city with IT parks, multinational companies, business districts, shopping malls, gardens, and modern infrastructure."
  }
],




"services": [
  {
    "name": "Cheapest Cab Service in Goa",
    "description": "Book the Cheapest Cab Service in Goa with affordable fares, clean AC vehicles, experienced drivers, transparent pricing, and reliable local as well as outstation travel available 24x7."
  },
  {
    "name": "Cheap Taxi in Goa",
    "description": "Choose Cheap Taxi in Goa for budget-friendly airport transfers, sightseeing, hotel pickups, one way rides, and comfortable chauffeur-driven travel."
  },
  {
    "name": "Cheapest Taxi Service in Goa",
    "description": "Hire the Cheapest Taxi Service in Goa with fixed pricing, online booking, professional chauffeurs, and well-maintained vehicles for every journey."
  },
  {
    "name": "Cheap Cabs in Goa",
    "description": "Reserve Cheap Cabs in Goa for family trips, business travel, airport transfers, sightseeing tours, and outstation travel at economical prices."
  },
  {
    "name": "Goa Cheap Taxi Service",
    "description": "Travel with Goa Cheap Taxi Service offering safe rides, transparent fares, sanitized vehicles, punctual pickups, and dependable customer support."
  },
  {
    "name": "Goa Cheap Taxi",
    "description": "Book Goa Cheap Taxi for convenient transportation with AC cars, experienced drivers, flexible pickup timings, and affordable pricing."
  },
  {
    "name": "Cheapest Cab Service in Goa",
    "description": "Choose the Cheapest Cab Service in Goa for reliable travel with Sedan, Ertiga, Innova Crysta, SUVs, and premium chauffeur-driven vehicles."
  },
  {
    "name": "Cheap Cab Service in Goa",
    "description": "Book Cheap Cab Service in Goa for local sightseeing, airport pickup, hotel transfers, and outstation trips with fixed fares."
  },
  {
    "name": "Affordable Cab Service in Goa",
    "description": "Enjoy Affordable Cab Service in Goa with comfortable vehicles, courteous drivers, online booking, and budget-friendly travel solutions."
  },
  {
    "name": "Budget Cab Service Goa",
    "description": "Reserve Budget Cab Service Goa for economical transportation with professional chauffeurs, clean cars, and hassle-free booking."
  },
  {
    "name": "Low Cost Cab Service Goa",
    "description": "Choose Low Cost Cab Service Goa for affordable one way, round trip, airport transfer, and sightseeing rides with transparent pricing."
  },
  {
    "name": "Cheap Taxi Service in Goa",
    "description": "Hire Cheap Taxi Service in Goa with fixed rates, punctual drivers, comfortable AC vehicles, and reliable customer assistance."
  },
  {
    "name": "Budget Taxi Service Goa",
    "description": "Book Budget Taxi Service Goa for cost-effective travel across Goa with flexible booking options and professional chauffeurs."
  },
  {
    "name": "Best Cheap Cab in Goa",
    "description": "Find the Best Cheap Cab in Goa offering affordable fares, premium service, clean vehicles, and dependable transportation for every trip."
  },
  {
    "name": "Cheapest Cab Booking Goa",
    "description": "Complete Cheapest Cab Booking Goa online with instant confirmation, secure reservations, and multiple vehicle options."
  },
  {
    "name": "Cheap Taxi Booking Goa",
    "description": "Reserve Cheap Taxi Booking Goa with quick online booking, transparent pricing, and 24x7 customer support."
  },
  {
    "name": "Online Cheap Cab Booking Goa",
    "description": "Book Online Cheap Cab Booking Goa for airport transfers, sightseeing, hotel pickups, and outstation journeys with ease."
  },
  {
    "name": "Goa Budget Taxi",
    "description": "Choose Goa Budget Taxi for economical travel with professional drivers, AC vehicles, and comfortable transportation."
  },
  {
    "name": "Goa Budget Cab",
    "description": "Hire Goa Budget Cab for reliable local and outstation travel with affordable pricing and excellent customer service."
  },
  {
    "name": "Cheapest Airport Cab Goa",
    "description": "Book Cheapest Airport Cab Goa with timely airport pickup, fixed fares, luggage assistance, and comfortable travel."
  },
  {
    "name": "Cheapest Dabolim Airport Cab",
    "description": "Reserve Cheapest Dabolim Airport Cab with experienced chauffeurs, affordable pricing, and reliable airport transfer services."
  },
  {
    "name": "Cheapest Mopa Airport Cab",
    "description": "Travel with Cheapest Mopa Airport Cab offering punctual pickup, AC vehicles, transparent fares, and professional drivers."
  },
  {
    "name": "Cheap Airport Taxi Goa",
    "description": "Book Cheap Airport Taxi Goa for dependable airport transportation with affordable fares and clean chauffeur-driven vehicles."
  },
  {
    "name": "Goa Outstation Cheap Cab",
    "description": "Choose Goa Outstation Cheap Cab for comfortable long-distance travel with fixed pricing, spacious vehicles, and experienced drivers."
  },
  {
    "name": "Goa One Way Cheap Cab",
    "description": "Reserve Goa One Way Cheap Cab with economical fares, instant booking, doorstep pickup, and comfortable travel."
  },
  {
    "name": "Cheapest Car Rental in Goa",
    "description": "Book the Cheapest Car Rental in Goa with Sedan, Ertiga, Innova Crysta, SUVs, and chauffeur-driven vehicles at affordable prices."
  },
  {
    "name": "Cheap Innova Crysta Goa",
    "description": "Hire Cheap Innova Crysta Goa for spacious family travel, airport transfers, corporate trips, and outstation journeys."
  },
  {
    "name": "Cheap Ertiga Cab Goa",
    "description": "Book Cheap Ertiga Cab Goa for six-seater family travel with comfortable seating, professional drivers, and budget-friendly fares."
  },
  {
    "name": "Cheap Sedan Cab Goa",
    "description": "Travel with Cheap Sedan Cab Goa offering economical pricing, AC comfort, punctual service, and smooth rides."
  },
  {
    "name": "Low Fare Taxi Goa",
    "description": "Choose Low Fare Taxi Goa for affordable local and outstation travel with experienced chauffeurs and transparent pricing."
  },
  {
    "name": "Best Budget Taxi Goa",
    "description": "Reserve Best Budget Taxi Goa with dependable drivers, clean vehicles, fixed fares, and quality travel services."
  },
  {
    "name": "Reliable Cheap Cab Goa",
    "description": "Book Reliable Cheap Cab Goa for safe, affordable, and comfortable transportation with 24x7 customer assistance."
  },
  {
    "name": "Discount Cab Service Goa",
    "description": "Choose Discount Cab Service Goa for economical airport transfers, sightseeing tours, and outstation travel with great value pricing."
  }
],

"tableData": [
  ["Cheapest Cab Service in Goa", "Cheap Taxi in Goa"],
  ["Cheapest Taxi Service in Goa", "Cheap Cabs in Goa"],
  ["Goa Cheap Taxi Service", "Goa Cheap Taxi"],
  ["Cheapest Cab Service in Goa", "Cheap Cab Service in Goa"],
  ["Affordable Cab Service in Goa", "Budget Cab Service Goa"],
  ["Low Cost Cab Service Goa", "Cheap Taxi Service in Goa"],
  ["Budget Taxi Service Goa", "Best Cheap Cab in Goa"],
  ["Cheapest Cab Booking Goa", "Cheap Taxi Booking Goa"],
  ["Online Cheap Cab Booking Goa", "Goa Budget Taxi"],
  ["Goa Budget Cab", "Cheapest Airport Cab Goa"],
  ["Cheapest Dabolim Airport Cab", "Cheapest Mopa Airport Cab"],
  ["Cheap Airport Taxi Goa", "Goa Outstation Cheap Cab"],
  ["Goa One Way Cheap Cab", "Cheapest Car Rental in Goa"],
  ["Cheap Innova Crysta Goa", "Cheap Ertiga Cab Goa"],
  ["Cheap Sedan Cab Goa", "Low Fare Taxi Goa"],
  ["Best Budget Taxi Goa", "Reliable Cheap Cab Goa"],
  ["Discount Cab Service Goa", ""]
],





whychoose: [
  {
    WhyChooseheading: "Affordable Cheapest Cab Service in Goa",
    WhyChoosedescription: "Belgaum Taxi Service offers budget-friendly taxi services in Goa with comfortable vehicles, professional drivers, and transparent pricing without compromising on quality."
  },
  {
    WhyChooseheading: "Pickup from Every Corner of Goa",
    WhyChoosedescription: "Reserve a cab from North Goa, South Goa, Dabolim Airport, Mopa Airport, railway stations, hotels, resorts, beaches, and popular tourist destinations."
  },
  {
    WhyChooseheading: "Economy to Premium Vehicle Options",
    WhyChoosedescription: "Choose from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers to match your budget, passenger count, and luggage requirements."
  },
  {
    WhyChooseheading: "Ideal for Local & Outstation Travel",
    WhyChoosedescription: "Our taxis are suitable for local sightseeing, airport transfers, business travel, beach hopping, and outstation trips from Goa to nearby cities."
  },
  {
    WhyChooseheading: "Professional Drivers for Safe Travel",
    WhyChoosedescription: "Every journey is handled by experienced chauffeurs who focus on safe driving, punctual arrivals, and courteous customer service."
  },
  {
    WhyChooseheading: "Transparent Fare Structure",
    WhyChoosedescription: "Receive a clear quotation before your trip with competitive pricing, flexible travel plans, and no hidden charges."
  },
  {
    WhyChooseheading: "One Way & Round Trip Booking",
    WhyChoosedescription: "Book economical one-way cabs or convenient round-trip taxis for holidays, family vacations, corporate travel, and airport transfers."
  },
  {
    WhyChooseheading: "24/7 Cab Reservation Support",
    WhyChoosedescription: "Plan your Goa travel anytime with instant booking confirmation and dedicated customer assistance available throughout the day."
  }
]

};

const faqData = [
  {
    question: "Does Belgaum Taxi Service provide the cheapest cab service in Goa?",
    answer: "Yes, Belgaum Taxi Service offers affordable taxi services in Goa with transparent pricing for local, airport, sightseeing, and outstation travel."
  },
  {
    question: "Can I book a budget-friendly taxi anywhere in Goa?",
    answer: "Yes, pickup is available from North Goa, South Goa, airports, railway stations, hotels, beaches, and all major tourist locations."
  },
  {
    question: "Which vehicles are available at economical fares?",
    answer: "You can choose from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers based on your travel requirements."
  },
  {
    question: "Do you provide Goa Airport taxi services?",
    answer: "Yes, airport pickup and drop services are available from both Dabolim Airport and Manohar International Airport (Mopa)."
  },
  {
    question: "Can I hire a taxi for Goa sightseeing?",
    answer: "Yes, affordable sightseeing taxi packages are available for North Goa, South Goa, beaches, forts, churches, waterfalls, and other attractions."
  },
  {
    question: "Is the taxi service available 24/7 in Goa?",
    answer: "Yes, our cab services are available around the clock for airport transfers, local rides, sightseeing, and outstation journeys."
  },
  {
    question: "Can I book one-way and round-trip taxis?",
    answer: "Yes, both one-way and round-trip taxi bookings are available with flexible travel schedules."
  },
  {
    question: "Are toll and parking charges included in the fare?",
    answer: "Toll charges, parking fees, and applicable state taxes are generally charged separately unless included in the confirmed quotation."
  },
  {
    question: "Do you provide outstation cabs from Goa?",
    answer: "Yes, we provide affordable taxi services from Goa to Belgaum, Gokarna, Hubli, Bangalore, Pune, Mumbai, and many other destinations."
  },
  {
    question: "How can I book the cheapest cab service in Goa?",
    answer: "Share your pickup location, destination, travel date, passenger details, and preferred vehicle to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Nilesh Sawant",
    feedback: "We found the fare very reasonable compared to other options. The vehicle was clean, the driver was punctual, and the entire Goa trip was comfortable and enjoyable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Ritu Sharma",
    feedback: "Excellent value for money with professional service throughout the journey. The booking was simple, the cab arrived on time, and our family had a pleasant travel experience.",
    rating: 5
  }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Cab Service in Belgaum", link: "Cab-Service-in-Belgaum" },
        { place: "/images/keyword/2.jpg", text: "Belgaum Taxi Service", link: "Belgaum-Taxi-Service" },
        { place: "/images/keyword/3.jpg", text: "Belgaum to Goa Cab", link: "Belgaum-to-Goa-Cab" },
        { place: "/images/keyword/4.jpg", text: "Belgaum to Mahabaleshwar Cab", link: "Belgaum-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Belgaum to Kerala Cab Service", link: "Belgaum-to-Kerala-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Goa to Belgaum Cab", link: "Goa-to-Belgaum-Cab" },
        { place: "/images/keyword/7.jpg", text: "Belgaum to Mumbai Cab", link: "Belgaum-to-Mumbai-Cab" },
        { place: "/images/keyword/8.jpg", text: "Belgaum to Bangalore Cab", link: "Belgaum-to-Bangalore-Cab" },
        { place: "/images/keyword/9.jpg", text: "Goa Cab Service", link: "Goa-Cab-Service" },
        { place: "/images/keyword/10.jpg", text: "Taxi Service in Goa", link: "Taxi-Service-in-Goa" },
        { place: "/images/keyword/11.jpg", text: "Cheapest Cab Service in Goa", link: "Cheapest-Cab-Service-in-Goa" },
        { place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Belgaum", link: "Corporate-Cab-Services-in-Belgaum" },
        { place: "/images/keyword/13.jpg", text: "Innova Crysta Rent in Belgaum", link: "Innova-Crysta-Rent-in-Belgaum" },
        { place: "/images/keyword/14.jpg", text: "Ertiga on Rent in Belgaum", link: "Ertiga-on-Rent-in-Belgaum" },
        { place: "/images/keyword/15.jpg", text: "Tempo Traveller Rent in Belgaum", link: "Tempo-Traveller-Rent-in-Belgaum" },
        { place: "/images/keyword/16.jpg", text: "Mini Bus Rental Belgaum", link: "Mini-Bus-Rental-Belgaum" },
        { place: "/images/keyword/17.jpg", text: "Swift Dzire on Rent in Belgaum", link: "Swift-Dzire-on-Rent-in-Belgaum" },
        { place: "/images/keyword/18.jpg", text: "Urbania on Rent in Belgaum", link: "Urbania-on-Rent-in-Belgaum" },
        { place: "/images/keyword/19.jpg", text: "Wedding Car Rental in Belgaum", link: "Wedding-Car-Rental-in-Belgaum" },
        { place: "/images/keyword/20.jpg", text: "Cabs in Belgaum", link: "Cabs-in-Belgaum" },
        { place: "/images/keyword/21.jpg", text: "Belgaum to Hubli Cab", link: "Belgaum-to-Hubli-Cab" },
        { place: "/images/keyword/22.jpg", text: "Belgaum to Dharwad Cab", link: "Belgaum-to-Dharwad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Belgaum to Kolhapur Cab", link: "Belgaum-to-Kolhapur-Cab" },
        { place: "/images/keyword/24.jpg", text: "Belgaum Airport Cab Service", link: "Belgaum-Airport-Cab-Service" },
        { place: "/images/keyword/25.jpg", text: "Belgaum to Bagalkot Cab", link: "Belgaum-to-Bagalkot-Cab" },
    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cheapest Cab Service in Goa",
  "image": "https://www.belgaumtaxiservice.com/assets/images/cheapest-cab-service-in-goa.webp",
  "description":
    "Book Cheapest Cab Service in Goa with Belgaum Taxi Service for affordable, safe, and comfortable taxi solutions. We provide budget-friendly local cabs, airport taxis, sightseeing taxis, and outstation cab services in Goa with Sedan, Ertiga, SUV, Innova, and Innova Crysta available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Belgaum Taxi Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.belgaumtaxiservice.com/cheapest-cab-service-in-goa"
  }
};




    return (
        <div>



<Helmet>
  <title>Cheapest Cab Service in Goa | Budget Taxi Booking | +91 8722158435</title>

  <meta
    name="description"
    content="Book Cheapest Cab Service in Goa with Belgaum Taxi Service for affordable local, airport, sightseeing, and outstation taxi services. Get budget cabs in Goa with Sedan, Ertiga, SUV, Innova, and Innova Crysta options available 24x7."
  />

  <meta
    name="keywords"
    content="Cheapest cab service in goa, Cheap taxi in goa, Cheapest taxi service in goa, Cheap cabs in goa, Goa cheap taxi service, Goa cheap taxi, Cheapest Cab Service in Goa, Cheap Cab Service in Goa, Affordable Cab Service in Goa, Budget Cab Service Goa, Low Cost Cab Service Goa, Cheapest Taxi Service in Goa, Cheap Taxi Service in Goa, Budget Taxi Service Goa, Best Cheap Cab in Goa, Cheapest Cab Booking Goa, Cheap Taxi Booking Goa, Online Cheap Cab Booking Goa, Goa Budget Taxi, Goa Budget Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




            <div className="page-headder bg-section parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="page-header-box text-white">
                                <h1 className="text-anime-style-3 text-center text-white">
                                    {cardData.keyword}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/11.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Belgaum Taxi Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Belgaum Taxi Service</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Belgaum Taxi Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918722158435 " className="pc-call">+91 8722158435 </a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918722158435 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918722158435 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@belgaumtaxiservice.com" className="pc-email">
                                            booking@belgaumtaxiservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Belgaum Taxi Service</strong><br />
                                            P No 30 cCTS No 7023,
                                            Sector No 9 Malmaruti Anjaneya Nagar,
                                            Belgaum, Karnataka - 590017




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Cheapestcabserviceingoa;